var Transactional_1;
import { __decorate, __rest } from "tslib";
import { abortIO } from './io-tools.js';
import { define, definitions, eventsApi, Messenger, mixinRules, mixins, throwingLogger } from './object-plus/index.js';
import { resolveReference } from './traversable.js';
import { ValidationError } from './validation.js';
const { trigger3, on, off } = eventsApi;
export var ItemsBehavior;
(function (ItemsBehavior) {
    ItemsBehavior[ItemsBehavior["share"] = 1] = "share";
    ItemsBehavior[ItemsBehavior["listen"] = 2] = "listen";
    ItemsBehavior[ItemsBehavior["persistent"] = 4] = "persistent";
})(ItemsBehavior || (ItemsBehavior = {}));
let Transactional = Transactional_1 = class Transactional {
    static onDefine(definitions, BaseClass) {
        if (definitions.endpoint)
            this.prototype._endpoint = definitions.endpoint;
        Messenger.onDefine.call(this, definitions, BaseClass);
    }
    ;
    static onExtend(BaseClass) {
        if (BaseClass.create === this.create) {
            this.create = Transactional_1.create;
        }
    }
    static create(a, b) {
        return new this(a, b);
    }
    dispose() {
        if (this._disposed)
            return;
        abortIO(this);
        this._owner = void 0;
        this._ownerKey = void 0;
        this.off();
        this.stopListening();
        this._disposed = true;
    }
    onChanges(handler, target) {
        on(this, this._changeEventName, handler, target);
    }
    offChanges(handler, target) {
        off(this, this._changeEventName, handler, target);
    }
    listenToChanges(target, handler) {
        this.listenTo(target, target._changeEventName, handler);
    }
    constructor(cid) {
        this._changeToken = {};
        this._transaction = false;
        this._isDirty = null;
        this._owner = void 0;
        this._ownerKey = void 0;
        this._validationError = void 0;
        this.cid = this.cidPrefix + cid;
    }
    transaction(fun, options = {}) {
        const isRoot = transactionApi.begin(this);
        const update = fun.call(this, this);
        update && this.set(update);
        isRoot && transactionApi.commit(this);
    }
    assignFrom(source) {
        this.transaction(() => {
            this.set(source.__inner_state__ || source, { merge: true });
            const { _changeToken } = source;
            if (_changeToken) {
                this._changeToken = _changeToken;
            }
        });
        return this;
    }
    static from(json, _a = {}) {
        var { strict } = _a, options = __rest(_a, ["strict"]);
        const obj = this.create(json, Object.assign(Object.assign({}, options), { logger: strict ? throwingLogger : void 0 }));
        if (strict && obj.validationError) {
            obj.eachValidationError((error, key, obj) => {
                throw new Error(`${obj.getClassName()}.${key}: ${error}`);
            });
        }
        return obj;
    }
    parse(data, options) { return data; }
    deepGet(reference) {
        return resolveReference(this, reference, (object, key) => object.get ? object.get(key) : object[key]);
    }
    getOwner() {
        return this._owner;
    }
    getStore() {
        const { _owner } = this;
        return _owner ? _owner.getStore() : this._defaultStore;
    }
    hasPendingIO() { return this._ioPromise; }
    getEndpoint() {
        return getOwnerEndpoint(this) || this._endpoint;
    }
    get validationError() {
        const error = this._validationError || (this._validationError = new ValidationError(this));
        return error.length ? error : null;
    }
    validate(obj) { }
    getValidationError(key) {
        var error = this.validationError;
        return (key ? error && error.nested[key] : error) || null;
    }
    deepValidationError(reference) {
        return resolveReference(this, reference, (object, key) => object.getValidationError(key));
    }
    eachValidationError(iteratee) {
        const { validationError } = this;
        validationError && validationError.eachError(iteratee, this);
    }
    isValid(key) {
        return !this.getValidationError(key);
    }
    valueOf() { return this.cid; }
    toString() { return this.cid; }
    getClassName() {
        const { name } = this.constructor;
        if (name !== 'Subclass')
            return name;
    }
};
Transactional = Transactional_1 = __decorate([
    define,
    definitions({
        endpoint: mixinRules.value
    }),
    mixins(Messenger)
], Transactional);
export { Transactional };
export const transactionApi = {
    begin(object) {
        return object._transaction ? false : (object._transaction = true);
    },
    markAsDirty(object, options) {
        const dirty = !options.silent;
        if (dirty)
            object._isDirty = options;
        object._changeToken = {};
        object._validationError = void 0;
        return dirty;
    },
    commit(object, initiator) {
        let originalOptions = object._isDirty;
        if (originalOptions) {
            while (object._isDirty) {
                const options = object._isDirty;
                object._isDirty = null;
                trigger3(object, object._changeEventName, object, options, initiator);
            }
            object._transaction = false;
            const { _owner } = object;
            if (_owner && _owner !== initiator) {
                _owner._onChildrenChange(object, originalOptions);
            }
        }
        else {
            object._isDirty = null;
            object._transaction = false;
        }
    },
    aquire(owner, child, key) {
        if (child._owner)
            throw new ReferenceError('Trying to aquire ownership for an object already having an owner');
        child._owner = owner;
        child._ownerKey = key;
    },
    free(owner, child) {
        if (owner === child._owner) {
            child._owner = void 0;
            child._ownerKey = void 0;
        }
    }
};
function getOwnerEndpoint(self) {
    const { collection } = self;
    if (collection) {
        return getOwnerEndpoint(collection);
    }
    if (self._owner) {
        const { _endpoints } = self._owner;
        return _endpoints && _endpoints[self._ownerKey];
    }
}
//# sourceMappingURL=transactions.js.map